import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "languages"
}
const _hoisted_5 = ["onClick", "disabled", "data-active"]
const _hoisted_6 = {
  key: 2,
  class: "error error--message"
}

import { onBeforeMount, onBeforeUnmount, onErrorCaptured, reactive } from 'vue';
    import LoaderComponent from '@/components/LoaderComponent.vue';
    import { AppStore } from '@/stores/app';
    import { MenuStore } from '@/stores/menu';
    import { ShopStore } from '@/stores/shop';
    import { Languages, ApiStatus } from '@/types';
    import { useI18n } from 'vue-i18n';
    import axios from "axios";

    interface State {
        langauges: string[],
        status: ApiStatus,
    }

    /* Props */

    /* Ref */

    /* Reactive */
    
export default /*#__PURE__*/_defineComponent({
  __name: 'LanguageSelectorPopup',
  setup(__props) {

    /* imports */
    const appStore = AppStore();
    const menuStore = MenuStore();
    const shopStore = ShopStore();
    const { locale } = useI18n();

    /* interface */
    const state = reactive<State>({
        langauges: [],
        status: {
            done: false,
            failed: false,
            loading: false
        }
    })

    /* Const */
    const languages: Languages = {
        sv: 'Svenska',
        fi: 'Suomi',
        en: 'English',
        ru: 'Russian',
        no: 'Norsk'
    }

    /* Emits */

    /* AbortController */
    const abortController = new AbortController();

    /* Functions */
    const hide = () => {
        appStore.state.showLangSelector = false;
    }

    const doNothing = () => {
        return false;
    }

    const setLang = (lang: string): void => {

        if (locale.value === lang) {
            return;
        }

        changeculture(lang)
            .then(() => {

                if (shopStore.id) {
                    menuStore.load(shopStore.id);
                }
                // Set locale value for i18n
                locale.value = lang;
                appStore.state.showLangSelector = false;
                document.documentElement.setAttribute("lang", locale.value);
            }).catch((err: Error) => {
                console.error('changeculture.catch', err.message);
                appStore.state.showLangSelector = false;
            });
    }

    const changeculture = async (lang: string) => {

        return new Promise((resolve: any, reject: any) => {
            
            axios.post(`/api/cultures/changeculture?cultureCode=${lang}`)
            .then(response => response.data)
            .then(() => {
                resolve(true);
            }).catch((err: Error) => {
                reject(err);
            });
        });
    }

    const loadLanguages = async () => {

        state.status.loading = true;
        axios.get<string[]>(`/api/cultures/languages`)
            .then(response => response.data)
            .then((data: string[]) => {
                state.langauges = data;
                state.status.done = true;

            }).catch((err: Error) => {
                state.status.failed = true;
                state.status.text = err.message;
            }).finally(() => {
                state.status.loading = false;
            });

    }



    /* Lifecycle Hooks */
    onErrorCaptured(() => {
        appStore.state.showLangSelector = false;
    });

    onBeforeMount(() => loadLanguages());

    onBeforeUnmount(() => abortController.abort());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, {
      name: "popup",
      duration: 860
    }, {
      default: _withCtx(() => [
        (_unref(appStore).state.showLangSelector)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "popup popup--languages",
              onClick: _withModifiers(hide, ["stop","prevent"])
            }, [
              _createElementVNode("div", {
                class: "popup__content",
                onClick: _withModifiers(doNothing, ["stop","prevent"])
              }, [
                (state.status.loading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(LoaderComponent, { text: "loader.languages" })
                    ]))
                  : _createCommentVNode("", true),
                (state.status.done && !state.status.loading)
                  ? (_openBlock(), _createElementBlock("ol", _hoisted_4, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.langauges, (lang) => {
                        return (_openBlock(), _createElementBlock("li", { key: lang }, [
                          _createElementVNode("a", {
                            onClick: ($event: any) => (setLang(lang)),
                            class: _normalizeClass({'btn--active': (_unref(locale) === lang) }),
                            disabled: (_unref(locale) === lang),
                            "data-active": (_unref(locale) === lang)
                          }, _toDisplayString(languages[lang]), 11, _hoisted_5)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (state.status.failed)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.t('error.heading')), 1),
                      _createElementVNode("p", null, _toDisplayString(state.status.text), 1)
                    ]))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_2)
            ], 8, _hoisted_1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})